import PriceFilter from './PriceFilter'

export default PriceFilter
